import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Dashboard.css';
import { format } from 'date-fns';

function Dashboard() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get('https://api.discovery.quantecsystems.com/sessions');
      setSessions(res.data);
    };
    fetchData();
  }, []);

  const handleDelete = async (sessionId) => {
  if (!window.confirm(`Delete session ${sessionId}?`)) return;

  try {
    await axios.delete(`https://api.discovery.quantecsystems.com/sessions/${sessionId}`);
    // Optionally refresh the session list after delete
    setSessions(prev => prev.filter(s => s.sessionId !== sessionId));
  } catch (err) {
    console.error("Failed to delete session:", err);
    alert("Could not delete session.");
  }
};


  return (
    <div className="dashboard-container">
      <h2>Discovery Sessions Dashboard</h2>
      <table className="dashboard-table">
        <thead>
          <tr>
            <th>Company</th>
            <th>Date</th>
            <th>Answers</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((s) => {
            const totalQuestions = 18; // can be dynamic if needed
            const completed = s.answerCount;
            const status = completed >= totalQuestions ? 'Completed' : 'In Progress';

            return (
              <tr key={s.sessionId}>
                <td>{s.companyName}</td>
                <td>{format(new Date(s.timestamp), 'PPP')}</td>
                <td>{completed}/{totalQuestions}</td>
                <td className={`status ${status === 'Completed' ? 'done' : 'in-progress'}`}>
                  {status}
                </td>
                <td>
                  <button className="view-btn" onClick={() => window.open(`/sessions/${s.sessionId}`, '_blank')}>View</button>
                  <button className="delete-btn" onClick={() => handleDelete(s.sessionId)}>Delete</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Dashboard;
